var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-input',_vm._g(_vm._b({attrs:{"tag":"textarea"},scopedSlots:_vm._u([{key:"error",fn:function(){return [_vm._t("error")]},proxy:true}],null,true)},'v-input',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }